'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  config: {
    useMinimalHeader: true,
    hideHeaderButtons: true
  },
  contentLoggedOut: {
    minimalHeader: {
      logo: {
        text: 'PayPal',
        href: '/webapps/mpp/home'
      }
    }
  },
  contentLoggedIn: {
    minimalHeader: {
      logo: {
        text: 'PayPal',
        href: '/webapps/mpp/home'
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/logo-only-header/jsx/LogoOnlyHeaderDefaultProps.js
// module id = 1116
// module chunks = 4